// Copyright (c) 2016 Deere & Company

import OtherCreditsPanelContainer from './other-credits-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    errors: state.claims.spa.claim.errors,
    isEditable: state.claims.spa.isEditable,
    otherCreditDescriptions: state.claims.otherCreditDescriptions,
    otherCredits: state.claims.spa.claim.otherCredits,
    specialAllowanceType: state.claims.spa.claim.specialAllowanceType.key
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(OtherCreditsPanelContainer);



// WEBPACK FOOTER //
// ./src/claim/spa/components/other-credits-panel/index.js